// OUD Journey v1 / Affiliate v6: context and attribution bridge. Shopping events come from Shopify Customer Events.
(function () {
  if(window.__ovnJourneyBridge)return;window.__ovnJourneyBridge=true;
  var ATTR='ov_affiliate_attribution_v2',PENDING='ov_affiliate_pending_capture_v1',CTX='ovn_journey_context_v1';
  var context=null,starting=false,allowed=false,attempt=0,rawSession='',rawVisitor='',syncPending=Promise.resolve(),bypass=false;
  var ready=false,engaged=0,lastTick=Date.now(),maxScroll=0,lastEngagement=0,lastTouch=0;
  var localStore,sessionStore;try{localStore=window.localStorage;}catch(e){}try{sessionStore=window.sessionStorage;}catch(e){}
  function get(s,k){try{return s.getItem(k);}catch(e){return null;}}
  function put(s,k,v){try{s.setItem(k,v);}catch(e){}}
  function remove(s,k){try{s.removeItem(k);}catch(e){}}
  function parse(s){try{return JSON.parse(s||'null');}catch(e){return null;}}
  function cookie(k){try{var v=document.cookie.split('; ').find(function(x){return x.indexOf(k+'=')===0;});return v?decodeURIComponent(v.slice(k.length+1)):'';}catch(e){return '';}}
  function setCookie(k,v,age){try{document.cookie=k+'='+encodeURIComponent(v)+'; Path=/; Max-Age='+age+'; SameSite=Lax; Secure'+(/(^|\.)oudvietnam\.com$/.test(location.hostname)?'; Domain=.oudvietnam.com':'');}catch(e){}}
  function id(){return crypto.randomUUID?crypto.randomUUID():'ovn-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2);}
  function slug(v){v=String(v||'').trim().toLowerCase();return /^[a-z0-9][a-z0-9_-]{0,99}$/.test(v)?v:'';}
  function path(){return location.pathname;}
  function attribution() {
    var p=new URLSearchParams(location.search),ref=slug(p.get('affiliate_ref')||(p.get('utm_source')==='affiliate'?p.get('utm_content'):''));
    if(ref){var a={slug:ref,campaign:slug(p.get('affiliate_campaign')||p.get('utm_campaign')),linkCode:slug(p.get('affiliate_link')),capturedAt:Date.now(),source:'affiliate'};
      put(sessionStore,PENDING,JSON.stringify(a));return a;}
    var pending=parse(get(sessionStore,PENDING));
    var saved=pending&&Date.now()-pending.capturedAt<86400000?pending:parse(get(localStore,ATTR));
    return saved&&slug(saved.slug)&&Date.now()-Number(saved.capturedAt)<30*86400000?saved:null;
  }
  function publish(name,data) {
    if(!allowed||!window.Shopify||!Shopify.analytics||!Shopify.analytics.publish)return;
    try{Promise.resolve(Shopify.analytics.publish(name,data)).catch(function(){});}catch(e){}
  }
  function touch(){if(allowed&&rawSession){
    var now=Date.now(),renew=false;
    if(lastTouch&&now-lastTouch>=1800000){rawSession=id();ready=false;context=null;renew=true;
      remove(sessionStore,CTX);setCookie(CTX,'',0);put(sessionStore,'ov_affiliate_session_v1',rawSession);}
    if(context&&context.expiresAt<=Math.floor(now/1000)+60){ready=false;renew=true;}
    lastTouch=now;setCookie('ovn_journey_session_v1',rawSession,1800);
    if(renew)Promise.resolve().then(start);
  }}
  function acceleratedNodes(){return document.querySelectorAll('shopify-accelerated-checkout,.shopify-payment-button');}
  function releaseAccelerated(){acceleratedNodes().forEach(function(el){if(el.dataset.ovnJourneyLocked==='1'){
    el.style.pointerEvents=el.dataset.ovnJourneyPointer||'';el.removeAttribute('aria-busy');delete el.dataset.ovnJourneyLocked;delete el.dataset.ovnJourneyPointer;
  }});}
  function lockAccelerated(){acceleratedNodes().forEach(function(el){if(el.dataset.ovnJourneyLocked!=='1'){
    el.dataset.ovnJourneyLocked='1';el.dataset.ovnJourneyPointer=el.style.pointerEvents||'';el.style.pointerEvents='none';el.setAttribute('aria-busy','true');
  }});}
  async function timedFetch(url,options){var timeout;try{return await Promise.race([fetch(url,options),
    new Promise(function(_,reject){timeout=setTimeout(function(){reject(new Error('timeout'));},8000);})]);}finally{clearTimeout(timeout);}}
  async function syncCart(a) {
    if(!a||!context)return;
    var attrs={'OVN Affiliate Slug':a.slug,'OVN Affiliate Campaign':a.campaign||'','OVN Affiliate Link':a.linkCode||'',
      'OVN Affiliate Captured At':new Date(a.capturedAt).toISOString(),'OVN Affiliate Source':'affiliate',
      'OVN Affiliate Session':rawSession,'OVN Journey Context':context.contextToken};
    var response=await timedFetch('/cart/update.js',{method:'POST',credentials:'same-origin',keepalive:true,
      headers:{'content-type':'application/json'},body:JSON.stringify({attributes:attrs})});
    if(!response.ok)throw new Error('cart-sync');
  }
  function retry(){if(attempt<6)setTimeout(start,Math.min(15000,500*Math.pow(2,attempt++)));}
  async function start() {
    if(!allowed||starting||ready)return;starting=true;
    var a=attribution();
    var resolveSync;syncPending=new Promise(function(resolve){resolveSync=resolve;});
    if(a){lockAccelerated();setTimeout(releaseAccelerated,1500);}
    try {
      if(!rawVisitor)rawVisitor=cookie('ovn_journey_visitor_v1')||get(localStore,'ov_affiliate_visitor_v1')||id();
      if(!rawSession)rawSession=cookie('ovn_journey_session_v1')||id();
      put(localStore,'ov_affiliate_visitor_v1',rawVisitor);put(sessionStore,'ov_affiliate_session_v1',rawSession);
      setCookie('ovn_journey_visitor_v1',rawVisitor,30*86400);touch();
      var response=await timedFetch('/apps/affiliate?action=journey_context',{method:'POST',credentials:'same-origin',keepalive:true,
        headers:{'content-type':'application/json'},body:JSON.stringify({analyticsAllowed:true,sessionId:rawSession,
          visitorId:rawVisitor,path:path(),affiliateSlug:a&&a.slug,campaignSlug:a&&a.campaign,linkCode:a&&a.linkCode})});
      if(!response.ok)throw new Error('context');
      var result=await response.json();
      if(!result.enabled||!result.contextToken){retry();return;}
      if(!allowed)return;
      context={contextToken:result.contextToken,expiresAt:result.expiresAt,sessionId:rawSession,requested:a?{slug:a.slug,linkCode:a.linkCode}:null};
      put(sessionStore,CTX,JSON.stringify(context));setCookie(CTX,JSON.stringify(context),48*3600);
      publish('ovn_journey_ready',{});
      if(result.attribution&&a){
        Object.assign(a,result.attribution);put(localStore,ATTR,JSON.stringify(a));remove(sessionStore,PENDING);
        await syncCart(a).catch(function(){setTimeout(function(){if(allowed)syncCart(a).catch(function(){});},1500);});
      }
      ready=true;
    } catch(e){retry();} finally{starting=false;resolveSync();releaseAccelerated();}
  }
  function privacyChanged() {
    allowed=Boolean(window.Shopify&&Shopify.customerPrivacy&&Shopify.customerPrivacy.analyticsProcessingAllowed());
    if(allowed){start();return;}
    context=null;ready=false;rawSession='';rawVisitor='';
    [CTX,'ovn_journey_session_v1','ovn_journey_visitor_v1'].forEach(function(k){setCookie(k,'',0);});
    remove(sessionStore,CTX);
    remove(sessionStore,'ov_affiliate_session_v1');remove(localStore,'ov_affiliate_visitor_v1');
  }
  function initPrivacy() {
    if(window.Shopify&&Shopify.customerPrivacy){privacyChanged();return;}
    if(window.Shopify&&Shopify.loadFeatures)Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){if(!error)privacyChanged();});
  }
  document.addEventListener('visitorConsentCollected',privacyChanged);
  document.addEventListener('click',function(event){
    touch();var target=event.target&&event.target.closest?event.target.closest('a,button[name="checkout"]'):null;
    if(!target)return;
    if(target.tagName==='A'&&target.origin===location.origin)publish('ovn_navigation_clicked',{destination:new URL(target.href).pathname});
    // Bounded wait only for an in-flight attribution write. No synthetic checkout events.
    if(!bypass&&allowed&&(starting||context)&&target.matches('a[href*="/checkout"],button[name="checkout"]')){
      event.preventDefault();event.stopImmediatePropagation();
      Promise.race([syncPending,new Promise(function(resolve){setTimeout(resolve,1200);})]).finally(function(){
        bypass=true;if(target.tagName==='A')location.assign(target.href);
        else if(target.form&&target.form.requestSubmit)target.form.requestSubmit(target);else target.click();bypass=false;
      });
    }
  },true);
  document.addEventListener('scroll',function(){var height=document.documentElement.scrollHeight-innerHeight;
    maxScroll=Math.max(maxScroll,height>0?Math.min(100,Math.round(scrollY/height*100)):100);},{passive:true});
  function engagement(){
    var now=Date.now();if(!document.hidden&&allowed){engaged+=Math.min(15,(now-lastTick)/1000);touch();}
    lastTick=now;
    if(allowed&&engaged-lastEngagement>=10){lastEngagement=engaged;publish('ovn_page_engagement',{engagedSeconds:Math.floor(engaged),scrollPercent:maxScroll});}
  }
  setInterval(engagement,15000);
  document.addEventListener('visibilitychange',function(){engagement();if(!document.hidden){attempt=0;start();}});
  window.addEventListener('online',function(){attempt=0;start();});
  window.addEventListener('pageshow',function(){initPrivacy();});
  initPrivacy();
})();
